export const normalizeDetail = (d) => ({
  ...d,
  form1: String(d.form1 ?? ""),
  form2: String(d.form2 ?? ""),
  form3: String(d.form3 ?? ""),
  form4: String(d.form4 ?? ""),
  form5: String(d.form5 ?? ""),
  form6: String(d.form6 ?? ""),
  form7: String(d.form7 ?? ""),
  form8: String(d.form8 ?? ""),
  form9: String(d.form9 ?? ""),
});
